import { useMutation } from 'react-query';
import PhotographerCalendarApi from '../../../SE360PhotographerBookingApi';
import { createCalendarItem } from '../../shared/bookingDateSelect/state/dateHelper';

export function useRebookOrderMutation(orderId: number) {
    return useMutation(
        ({
            timeslot,
            photographerId,
            planOrderId
        }: {
            timeslot: string;
            photographerId: number;
            planOrderId: number;
        }): Promise<void> => {
            let calendarItem = createCalendarItem(photographerId, timeslot);

            return PhotographerCalendarApi.updatePhotographerCalendar({
                //@ts-ignore
                calendarItem: {
                    ...calendarItem,
                    orderId
                },
                planOrderId,
                isAdvanced: false
            });
        }
    );
}
